import * as actions from "Actions";
import * as api from "Api";

export const fetchEvents = () => (dispatch, getState) => {
  const { auth } = getState();
  const { token, user } = auth;

  if (token === "") {
    return api.getClientCredential().done(resp => {
      const clientToken = resp.token.access_token;
      dispatch(actions.setAuthToken(clientToken));
      return dispatch(
        actions.fetchEvents(
          api
            .getEventIds({
              token: clientToken,
              userId: user.id
            })
            .then(resp => {
              console.log(resp);
            })
        )
      );
    });
  }
  return dispatch(
    actions.fetchEventIds(
      api
        .getEventIds({
          token,
          userId: user.id
        })
        .then(resp => {
          if (resp && resp.data && resp.data.data && resp.data.data.events) {
            dispatch(
              actions.fetchEvents(
                api.getEvents({
                  token,
                  ids: resp.data.data.events
                })
              )
            );
          }
          return resp;
        })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/event.js